<h1 mat-dialog-title>{{ 'nfcAccessLogs.detail.title' | translate }}
  <span class="text-muted" *ngIf="property">- {{ property.name }}</span>
</h1>

<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content>

<div class="row w-100 mt-5" mat-dialog-actions>
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->